<div class="container my-3">
  <!-- <h1 class="mb-3">Add Plant</h1> -->
  <form #form="ngForm" (ngSubmit)="addPlant()">
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Type</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          [(ngModel)]="addPlantRequest.Type"
          name="Type"
          #addPlanttype="ngModel"
        >
          <option [ngValue]="null" disabled>Select Type</option>
          <option value="3">SWRO</option>
          <option value="1">BWRO</option>
        </select>
        <div
          *ngIf="
            addPlantRequest.Type === null &&
            (addPlanttype.touched || addPlanttype.dirty)
          "
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
        <div
          *ngIf="TypeError"
          class="text-danger"
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Company</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          [(ngModel)]="addPlantRequest.CompanyId"
          name="CompanyId"
          #companyId="ngModel"
        >
          <option value="null" selected>Select Company</option>
          <option
            *ngFor="let company of companys"
            value="{{ company.Id }}"
            selected
          >
            {{ company.Name }}
          </option>
        </select>
        <div
          *ngIf="
            addPlantRequest.CompanyId === null &&
            (companyId.touched || companyId.dirty)
          "
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
        <div
          *ngIf="CompanyError"
          class="text-danger"
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Region</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          [(ngModel)]="addPlantRequest.Region"
          name="Region"
          #region="ngModel"
        >
          <option [ngValue]="null" disabled>Select Region</option>
          <option value="Americas">Americas</option>
          <option value="EMEA">EMEA</option>
          <option value="APAC">APAC</option>
        </select>
        <div
          *ngIf="
            addPlantRequest.Region === null && (region.touched || region.dirty)
          "
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
        <div
          *ngIf="RegionError"
          class="text-danger"
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
      </div>
    </div>
  </form>

  <form [formGroup]="AddPlantForm" (ngSubmit)="addPlant()">
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="Location" class="form-label">Location</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="Location"
          name="Location"
          formControlName="Location"
          [ngClass]="{
            'is-invalid':
              (submitted || AddPlantForm.controls.Location.touched) &&
              AddPlantForm.controls.Location.errors
          }"
        />
        <div
          *ngIf="
            (submitted || AddPlantForm.controls.Location.touched) &&
            AddPlantForm.controls.Location.errors
          "
          class="text-danger"
          style="text-align: left"
        >
          Location is required
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="Name" class="form-label">Name</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="Name"
          name="Name"
          formControlName="Name"
          [ngClass]="{
            'is-invalid':
              (submitted || AddPlantForm.controls.Name.touched) &&
              AddPlantForm.controls.Name.errors
          }"
        />
        <div
          *ngIf="
            (submitted || AddPlantForm.controls.Name.touched) &&
            AddPlantForm.controls.Name.errors
          "
          class="text-danger"
          style="text-align: left"
        >
          Name is required
        </div>
      </div>
    </div>
  </form>
  <form #form="ngForm" (ngSubmit)="addPlant()">
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Description</label>
      </div>
      <div class="col-sm-4">
        <textarea
          type="number"
          class="form-control border border-dark"
          id="description"
          name="description"
          [(ngModel)]="addPlantRequest.Description"
          required
        ></textarea>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Thumbnail</label>
      </div>
      <div class="col-sm-4">
        <input
          type="file"
          class="form-control-file"
          id="thumbnail"
          (change)="addFile(input.files)"
          name="thumbnail"
          [(ngModel)]="addPlantRequest.Thumbnail"
          #input
          required
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Attachments</label>
      </div>
      <div class="col-sm-4">
        <input
          type="file"
          class="form-control-file"
          ngf-select
          ng-Model="new_files"
          (change)="addFile(input1.files)"
          id="attachments"
          name="attachments"
          [(ngModel)]="addPlantRequest.Attachments"
          #input1
          required
        />
      </div>
    </div>

    <div style="min-height: 30px"></div>
    <div class="row">
      <div class="col-sm-2" style="text-align: right">
       
      </div>
      <div class="col-sm-2" style="text-align: left">
        <button type="submit" class="btn custom-buttons-btn mt-3">Submit</button>
      </div>
    </div>
  </form>
</div>
